// import Inputmask from './inputMask'


export default function addEmailMask(){

    let im = new Inputmask(
        {
        mask:"*{2,20}[.*{1,20}][.*{1,20}][.*{1,20}]@*{2,20}.*{2,6}[.*{1,6}]",
            greedy: false,
        onBeforePaste: function (pastedValue, opts) {
            pastedValue = pastedValue.toLowerCase();
            return pastedValue.replace("mailto:", "");
        },
        definitions: {
            '*': {
                validator: "[0-9A-Za-z!#$%&'*+/=?^_`{|}~\-]",
                casing: "lower"
            }
        }
    }
    )
    if(document.querySelectorAll('.js-email-mask').length >0){
        document.querySelectorAll('.js-email-mask').forEach((element)=>{
             im.mask(element)

        })
    }
}